/**
 * This class is auto generated by using the
 * "Dots.KLASIS.TsGenerator".
 * */
export const globalSearch = {

    infoBox: {
        contactEmail: `vards.uzvards@csp.gov.lv`,
        contactJobTitle: `Vecākais speciālists`,
        contactName: `Anna Kalniņa`,
        contactPhoneNumber: `+371 12345678`,
        subtitle: `Ja neizdodas atrast nepieciešamo informāciju vai Tev ir ierosinājumi, kā uzlabot meklētāju, sazinies ar mums telefoniski vai elektroniski un mēs Tev palīdzēsim.`,
        title: `Neatradi meklēto?`,
    },
}
